import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { emailValidator } from 'src/app/shared/validators/email-validator';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { AuthService } from '../../shared/services/auth.service';
import { Subscription, Observable, timer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseFormGroup implements OnInit {

  hide = true;
  disable = true;

  public formDetails: FormGroup;
  public loginResponse: any;
  public isLoading = false;
  public showError = false;
  public clientValidated = false;
  public clientValidationError: string;
  private client: any;
  public forgotPasswordLink: string;
  errorMsg: any;

  showLogin = false;
  private subscription: Subscription;
  private timer: Observable<any>;


  constructor(private loginService: LoginService,
              private authService: AuthService, private router: Router,
              private activatedRoute: ActivatedRoute,
              private commonService: CommonService) {
    super();
  }

  ngOnInit() {
    this.commonService.setLoadingFalse();

    const client = this.activatedRoute.snapshot.params.client;
    const queryParams = {
      clientName: client,
    };

    this.authService.setClientInfo({ client });
    this.forgotPasswordLink = `/${client}/forgot-password`;
    if (client) {
      this.isLoading = true;
      this.authService.getClientBuid(queryParams).subscribe((response) => {
        this.isLoading = false;
        this.client = response;
        this.clientValidated = true;
      }, (response) => {
        this.isLoading = false;
        this.clientValidationError = response.error.message;
      });
    }

    this.formDetails = new FormGroup({
      email: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required])
    });
  }

  checkInput() {
     if (this.formDetails.value.email.length > 0 ) {
      this.showLogin = true;
    }

     if (this.formDetails.value.email.length == 0) {
      this.showLogin = false;
    }

  }

  onSubmit() {
    if (this.formDetails.valid) {
      this.isLoading = true;
      const body = {
        client: this.client?.client,
        buids: this.client?.buids,
        username: this.formDetails.get('email').value,
        password: btoa(this.formDetails.get('password').value),
      };
      this.loginService.login(body).subscribe((response) => {
        this.loginResponse = response;
        this.isLoading = false;
        this.authService.setUserInfo(this.loginResponse);
        this.authService.setClientInfo(this.client);
        this.authService.setloginInfoSubject(true);
        this.router.navigate(['bookings-view']);
        if (localStorage.getItem('bookingId') && localStorage.getItem('startDate')) {
            this.router.navigate(['bookings/bookings-view']);
          } else {
            this.router.navigate(['']);
          }
      }, (response) => {
        this.isLoading = false;
        this.errorMsg = response.error.message;
        this.showError = true;
        this.timer = timer(5000);
        this.subscription = this.timer.subscribe(() =>  this.showError = false
    );
      });
    } else {
      this.markFormGroupDirty(this.formDetails);
    }
  }



  dismissError() {
    this.showError = false;
  }


}


